module.exports = __webpack_public_path__ + "img/boxfullwhite.d4a8e2fe.png";